import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronUp, ChevronDown } from "lucide-react";

export const scrollToY = (target, immediate = false) => {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(target, { immediate, duration: 1.2 });
  else window.scrollTo({ top: target === "bottom" ? document.body.scrollHeight : target, behavior: immediate ? "auto" : "smooth" });
};

export function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) scrollToY(0, true);
  }, [pathname, hash]);
  return null;
}

export function ScrollButtons() {
  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setAtTop(y < 80);
      setAtBottom(y + window.innerHeight >= document.documentElement.scrollHeight - 200);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const btn = "w-11 h-11 flex items-center justify-center text-[#1B2A4E] hover:bg-[#E8842C] hover:text-white disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-[#1B2A4E] transition-colors duration-300";
  return (
    <div data-testid="scroll-buttons" className="fixed bottom-28 end-6 z-[90] flex flex-col rounded-full border border-white/60 bg-white/35 backdrop-blur-xl shadow-lg shadow-[#1B2A4E]/15 overflow-hidden">
      <button data-testid="scroll-top-btn" aria-label="Scroll to top" disabled={atTop} onClick={() => scrollToY(0)} className={btn}>
        <ChevronUp className="w-5 h-5" />
      </button>
      <span className="h-px bg-[#1B2A4E]/15 mx-2" />
      <button data-testid="scroll-bottom-btn" aria-label="Scroll to bottom" disabled={atBottom} onClick={() => scrollToY("bottom")} className={btn}>
        <ChevronDown className="w-5 h-5" />
      </button>
    </div>
  );
}
